import React from "react";
import { ConselhoDetailsPage } from "./conselhoDetails.page";
import { ConselhoDetailsProvider } from "./context/conselho-details-context";

export function ConselhoDetailsFactory() {
    return (
        <ConselhoDetailsProvider>
            <ConselhoDetailsPage />
        </ConselhoDetailsProvider>
    );
}
